import TemplateProfileActivation from '../../app/templates/TemplateProfileActivation'
import DashboardIdentifiersForPartners from '../../app/pages/DashboardIdentifiersForPartners'

export default {
  path: '/minha-veloe/:id',
  component: TemplateProfileActivation,
  routes: [
    {
      exact: true,
      path: '/minha-veloe/:id/identificadores-parceiros/',
      component: DashboardIdentifiersForPartners
    },
    {
      exact: true,
      path: '/minha-veloe/:id/resumo/',
      component: DashboardIdentifiersForPartners
    }
  ]
}



// WEBPACK FOOTER //
// ./src/routes/profileActivation/dashboard.js